'use strict';
/**
* Диалог создания нескольких документов
*
* @class WebAccess.components.dialogs.MassCreateDocument
* @since 5.6.2.1000
* @extends WebAccess.components.dialogs.BaseDialog
*
* @example
* // Открытие диалогового окна «Создание документов».
* var dialog  = new WA.CMP.dialogs.MassCreateDocument()
* dialog.fileList = files;
* dialog.bind('loaded', function() {
*   alert('ok')
* });
* dialog.bind('create', function(res) {
*   res.forEach(function(item) { item.toURL().open(); });
* });
* dialog.show(fileNames);
*/
/**
 * Событие срабатывает при открытии окна создания документов.
 * @event  WebAccess.components.dialogs.MassCreateDocument#open
 */
/**
 * Событие срабатывает после загрузки содержимого окна создания документов.
 * @event  WebAccess.components.dialogs.MassCreateDocument#loaded
 */
/**
 * Событие срабатывает после нажатия на кнопку «Создать».
 * @event  WebAccess.components.dialogs.MassCreateDocument#ok
 */
/**
 * Событие срабатывает после создания документа.
 * @event  WebAccess.components.dialogs.MassCreateDocument#create
 * @param {Link} doc Ссылка на созданные документы
 *
 */
(function (global) {
  class MassCreateDocument extends global.BaseDialog {
    constructor(settings) {
      super(settings);
      /**
       * @see BaseDialog.title
       * @see BaseDialog.width
       * @see BaseDialog.height
       * @property {string} className css класс диалога
       * @property {object} _jWindow jQery объект диалогового окна
       * @see BaseDialog.isShowCancelButton
       * @property {object] fileList список файлов
       * @see BaseDialog.id
       * @property {string} dialogSelector селектор диалога для jQuery
       */
      this.title = L('MODAL_DIALOG_SELECT_ITEMS');
      this.width = 650;
      this.height = 'auto';
      this.className = 'MassCreateDocument';
      this.mode = 'create';
      this._jWindow = null;
      this.isShowCancelButton = true;
      this.fileList = null;
      this.id = 'dnd_dialog';
      this.dialogSelector = `#${this.id}`;
    }

    /**
     * При нажатии на "Создать" отправляется форма с файлами
     * @method ok
     */
    ok() {
      const rnd = Math.floor(Math.random() * 10000).toString();
      const jWindow = this._jWindow;
      log.info('DRAG&DROP', `Creating ${this.fileList.length} file(s)`);

      if (this.isFormValid(jWindow)) {
        $('*[data-name="OkButton"]').attr('disabled', true);
        let fData = new FormData(jWindow.find('form')[0]);
        $(this.fileList).toArray().forEach(file => fData.append('file', file, file.name));


        let xhr = new XMLHttpRequest();
        xhr.open('POST', '/Upload.ashx?c=dyn_new_document', false);
        xhr.onreadystatechange = (() => {
          if (xhr.readyState === 4) {
            if (xhr.response.indexOf("Error:") !== -1) {
              jWindow.data('error')(xhr.response.split(':')[1]);
            } else {
              jWindow.data('success')(xhr.response);
            }
          }
        });
        xhr.send(fData);
        return false;
      }
      else {
        jWindow.data('error')(L('NOT_ALL_REQUIRED_FIELDS_FILLED'));
        return false;
      }
    }

    /**
     * Инициализация jQuery объектов и навешивание на них событий, 
     * функция вызывается когда модальное окно и все его элементы загружены.
     * @method _postInit
     * @private
     */
    _postInit() {
      const jWindow = this._jWindow;
      jWindow.data('success', (res) => {
        const linkArr = [];
        const resArr = res.split(';');
        resArr.forEach((item) => {
          const url = new WA.URL(item);
          const id = url.getParam('id');
          const link = new WA.Link(id, OBJECT_TYPE.EDOCUMENT);
          link.isNew = true;
          link.folder = url.getParam('folder');
          linkArr.push(link);
        });
        log.info('DRAG&DROP', `${resArr.length} file(s) created`);
        this.fire('create', linkArr);
        this.close();
      }).data('error', (res) => {
        log.info('DRAG&DROP', 'An error occurred while creating file(s)');
        this.inlineHint.show(res);
        this.fire('error', res);
      });
      this.fire('loaded');
    }

    /**
     * Проверка заполненности контролов в диалоге
     * @function isFormValid
     * @param {object} jWindow jQuery объект диалогового окна
     * @return {boolean} true - когда обязательные поля заполнены, иначе false
     */
    isFormValid(jWindow) {
      if ((!jWindow.find('input[name=refVid]').val()) ||
        (!jWindow.find('input[name=refCardType]').val()) ||
        (!jWindow.find('input[name=refApp]').val())) {
        return false;
      }
      return true;
    }

    /**
     * Вызывается сразу после открытия модалки, навешивает события на эелементы списков
     * @method _initEvents
     * @private
     */
    _initEvents() {
      this._initSelectedItemsEvents();
      this._InitAvailableItemsListEvents();
      this._initFilterInputEvents();
      this.bind('itemSelect', () => {
        this.isSelectionChanged = true;
      });
      this.bind('itemUnSelect', () => {
        this.isSelectionChanged = true;
      });
      this._initExtraEvents();
    }
  
    /**
     * Показать диалог
     * @method show
     * @param {object} fileList - список файлов в диалоге
     */
    show(fileList) {
      const title = fileList.length > 1 ? L('CREATE_DOCUMENTS') : L('CREATE_DOCUMENT');
      this.okText = L('CREATE');

      this.setSpinner();
      let folderId = GetParamInURL('id');
      if (!folderId) {
        folderId = FavoritesFolderID;
      }
      const data = {
        Mode: 'create',
        FolderID: folderId,
        Files: fileList,
      };
      const args = {
        ControlName: 'mass_new_document',
        Params: $.toJSON(data),
      };
      WA.SRV.call('/ModalWindow.asmx/Create', args).done((data) => {
        this.setTitle(title);
        this.setHtml(`<div id=${this.id}>${data.html}</div>`);
        super.show();
        this._jWindow = $(this.dialogSelector);
        this._postInit();
        moveOpenedDialogToCenter();
      }).fail(() => {
        this.close();
      });

      return this;
    }

  }
  global.MassCreateDocument = MassCreateDocument;
})(window.WebAccess.components.dialogs);
